module.exports = __webpack_public_path__ + "static/media/XButton.46b7c32b.svg";